// Simple mock helpers with artificial delay
export const sleep = (ms = 500) => new Promise(res => setTimeout(res, ms));

let idCounter = 3;

export const makeId = () => `${Date.now()}_${idCounter++}`;
